module.exports = __webpack_public_path__ + "static/media/REP.ba2b5ca3.svg";